import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { ExternalProviderStatusService } from './external-provider-status.service';

export const externalProviderGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const externalProviderStatusService = inject(ExternalProviderStatusService);

  return externalProviderStatusService.externalReviewsEnabled$.pipe(
    map((externalEnabled) => (externalEnabled ? 'external' : 'existing')),
    map((path) =>
      router.createUrlTree(['reviews', 'import', path], {
        queryParams: route.queryParams,
      }),
    ),
  );
};
